<template>
    <div class="productItem">
        <div class="imgMark">
            <img class="img" :src="`${baseUrl}img/productItem/${img}.jpg`" style="display:block;" alt="" srcset="">        
        </div>
        <p class="text">{{text}}</p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:[
        'img','title','text'
    ]
}
</script>
<style lang="less">
.productItem{
    width: 100%;
    cursor: pointer;
    .img{
        width: 100%;
        transition: 0.3s all linear;
        display: block;
    }
    .imgMark{
        width: 100%;
        display: block;
        overflow: hidden;
    }
    .text{
        width: 100%;
        height: 1.8rem;
        overflow-y: scroll;
        line-height: 1.8rem;
        color: #444444;
        transform: translateY(-0.5rem);
        word-wrap:break-word ;
        font-size: 0.8rem;
    }
    .text::-webkit-scrollbar {display:none}
}
.productItem:hover{
    .img{
        transform: scale(1.1);
    }
}
</style>

